import React, { useEffect, useState, useRef } from "react";
import { useSpring } from "react-spring";
import "../../Components/componentsStyle.css";
import tataPlayLogo from "../../Images/tata-sky-logo.jpg";

import { Player, Controls } from "@lottiefiles/react-lottie-player";
import Icon from "@ant-design/icons/lib/components/Icon";

import { RobotOutlined } from "@ant-design/icons";

import FeedbackPopUp from "../../Components/FeedbackPopUp/FeedbackPopUp";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import Conversation from "../Conversation/conversation";
import RelatedArticles from "../Conversation/RelatedArticles";
import apiService from "../../Services/apiServices";

export default function MainChatPage(props) {
  const fadeIn = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 1000 }, // You can adjust the duration as needed
  });
  const {
    messages,
    addMessages,
    minimized,
    clearMessages,
    loading,
    updateMessage,
    setIsShowMaximumChat,
    showMaximumChat,
    setShowMinimizedChat,
    showMinimizedChat,
    userDetails,
    setToken,
    isShowBot,
    setIsShowBot,
    setCode,
    token,
    sessionId,
    reLogin,
    setRelogin
    
  } = props;
  const probing = false;

  const [inputValue, setInputValue] = useState("");
  const [customerInputs, setCustomerInputs] = useState("");
  const [showBotFlow, isSetBotFlow] = useState(false);
  const [showMsgs, setShowMsgs] = useState(false);
  const [isFeedbackPop, setIsFeedbackPop] = useState(false);
  const [IsThirtyMinPopUP ,setIsThirtyMinPopUP] = useState(false)

  const [finalTimerFlag, setFinalTimerFlag] = useState(false);
  const [disableInputBox , setDisableInputBox] = useState(false);
  const [checkThumsDownFeedback ,setCheckThumsDownFeedback] = useState([])
  const [IndexForPopUp , setIndexForPopUp]= useState(Number)

  const messagesEndRef = useRef(null);
  const hasEffectRun = useRef(false);


  let idleTimer;
  let secondIdleTimer;
  let finalTimer;

  const [idleTime, setIdleTime] = useState(0);

  useEffect(() => {
    let isFinalTimerTriggered = false;

    const handleUserActivity = () => {
      clearTimeout(idleTimer);
      clearTimeout(secondIdleTimer);

      // if (!chatEnd) {
      //   setIdleTime(0);
      // }

      if ( !isFinalTimerTriggered) {
        clearTimeout(finalTimer);

        // idleTimer = setTimeout(() => {
        //   setIdleTime(idleTime + 1);
        //   let initialArray = [];
        //   initialArray.push({
        //     uiCommand: "idle",
        //     text: "Hey there! We're eagerly waiting for you & we'd love to help you with your query.",
        //   });
        // }, 5 * 60 * 1000);

        // secondIdleTimer = setTimeout(() => {
        //   setIdleTime(idleTime + 1);
        //   let initialArray = [];
        //   initialArray.push({
        //     uiCommand: "idle",
        //     text: "Hey there! We're eagerly waiting for you & we'd love to help you with your query.",
        //   });
        // }, 10 * 60 * 1000);

        finalTimer = setTimeout(() => {
          // setIdleTime(idleTime + 1);
          // setDisableBtns((val) => !val);
          setFinalTimerFlag(true)
          // props.setIsSessionExpired(true);
          // isFinalTimerTriggered = true;
          setIsThirtyMinPopUP(true)
          setShowMsgs(false)
          setDisableInputBox(true)
          // props.setShowIdlePopup(true);
        }, 30 * 60 * 1000);
      }
    };

    const resetIdleTimer = () => {
      handleUserActivity();
    };

    if (!finalTimerFlag  && !props.isChatWithUs) {
      console.log("INSIDE add event listner", finalTimerFlag);
      // window.addEventListener("mousemove", resetIdleTimer);
      // window.addEventListener("keydown", resetIdleTimer);
      window.addEventListener("click", resetIdleTimer);
    }

    console.log("First render");
    console.log("IS FINAL timer triggerded? ", isFinalTimerTriggered);

    // if (chatEnd) {
    //   console.log("Re-render");
    //   clearTimeout(idleTimer);
    //   clearTimeout(secondIdleTimer);
    //   clearTimeout(finalTimer);
    //   // window.removeEventListener("mousemove", resetIdleTimer);
    //   // window.removeEventListener("keydown", resetIdleTimer);
    //   window.addEventListener("click", resetIdleTimer);
    // }
    return () => {
      clearTimeout(idleTimer);
      clearTimeout(secondIdleTimer);
      clearTimeout(finalTimer);
      // window.removeEventListener("mousemove", resetIdleTimer);
      // window.removeEventListener("keydown", resetIdleTimer);
      window.addEventListener("click", resetIdleTimer);
    };
  }, []);

  useEffect(() => {
    if (finalTimerFlag) {
      let n = document.getElementsByClassName("action-tab");

      for (let i = 0; i < n.length; i++) {
        n[i].disabled = true;
        n[i].style.cursor = "not-allowed";
      }
    }
  }, [finalTimerFlag]);


  const scrollToBottom = () => {
    messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    // Alternatively, adjust scroll top based on scrollHeight
    messagesEndRef.current.scroll({
      top: messagesEndRef.current.scrollHeight,
      behavior: "smooth",
    });
  };

  useEffect(()=>{
    if(reLogin){
      startLogin()
      setRelogin(false)
    }
    
  },[reLogin])

  const handleKeyPress = (event) => {
    if (event.key === "Enter" && inputValue.length > 0 && inputValue.trim() !== "") {
      setShowMsgs(true);
      addMessages(inputValue);
      setInputValue("");
    }
  };

  const onSendMsg = () => {
    if (inputValue.length > 0) {
      isSetBotFlow(true);
    }
  };

  const handleClose = () => {
    setIsShowBot(false);
    setIsShowMaximumChat(false);
  };

  const handleSend = () => {
    if (inputValue.length > 0 && inputValue.trim() !== "") {
      addMessages(inputValue);
      setShowMsgs(true);
    }

    setInputValue("");
  };

  const handleInput = (e) => {
    setInputValue(e.target.value);
    setCustomerInputs(e.target.value);
  };

  const chatReopenFunction = (token) => {
    sessionStorage.setItem("token", token);
    // setLoginLoader(true);
    apiService.inputResonse({ token, refresh: false, bot: "agent-assist" }).then((response) => {
      let data = response?.data?.chatResponse?.entries;
      
      if (data) {
          setCode(data[1]?.code); 
      }
  });
  
  };

  const startLogin = () => {
    const sessionValue = sessionStorage.getItem("agenIdS360");
    const userSession = sessionStorage.getItem("userIdS360");
    const user =
      sessionValue !== null && sessionValue !== "undefined"
        ? sessionValue
        : userDetails || userSession;

    if (user) {
      apiService
        .loginForLink(user)
        .then((response) => {
          const token = response?.data?.token;
          const userInfo = response?.data?.userInfo;

          chatReopenFunction(token);
          setToken(token);
          sessionStorage.setItem("token", token);

          const userName = userInfo?.customerName || "Testing";
          localStorage.setItem("userName", JSON.stringify(userName));
        })
        .catch((error) => {
          console.error("Error during loginForLink API call:", error);
        });
    } else {
      console.log("sendNewOutsideLinkApi", props.userDetails);
    }
  };

  const onClickEvent = () => {
    setIsShowBot(true);
    startLogin();
  };


  useEffect(() => {
    if (hasEffectRun.current) return;
    
    const timeoutId = setTimeout(() => {
      onClickEvent();
      hasEffectRun.current = true;
    }, 1000);

    return () => clearTimeout(timeoutId); // Cleanup in case component unmounts

  }, []);

  useEffect(() => {
    if (messagesEndRef.current) {
      scrollToBottom();
    }
  }, [messages, isFeedbackPop]);

  useEffect(() => {
    setFinalTimerFlag(true)
  }, [messages]);

  //msg.type !== "CUSTOMER" && showMaximumChat

  const checkIntroPage = () => {
    if (messages?.length === 0 && showMaximumChat) {
      return true;
    }
  };

  // main UI starts here
  return (
    <div
      className={
        showMinimizedChat
          ? "minimizedPageWrapper"
          : showMaximumChat
          ? "fullPageWrapper"
          : "wrapper"
      }
    >
      {/* //feedback popUp */}
      {showMaximumChat && isFeedbackPop && (
        <FeedbackPopUp
          setIsFeedbackPop={setIsFeedbackPop}
          showMaximumChat={showMaximumChat}
          sessionId={sessionId}
          setCheckThumsDownFeedback={setCheckThumsDownFeedback}
          checkThumsDownFeedback={checkThumsDownFeedback}
          index={IndexForPopUp}
        />
      )}

      

      {!isShowBot && (
        <div style={{fontSize : '1.75rem'}} className="bot-icon bot-icon-iframe">
          <RobotOutlined onClick={() => onClickEvent()} />
        </div>
      )}

      {isShowBot && (
        <div
          className={
            showMinimizedChat
              ? "minimizedPageContainer minimized-screen"
              : showMaximumChat
              ? "fullPageBotContainer"
              : "bot-container chatIn-header"
          }
        >
          {
            <Header
              handleClose={handleClose}
              showMinimizedChat={showMinimizedChat}
              showMaximumChat={showMaximumChat}
              setShowMinimizedChat={setShowMinimizedChat}
              setIsShowMaximumChat={setIsShowMaximumChat}
              clearMessages={clearMessages}
              setShowMsgs={setShowMsgs}
              startLogin={startLogin}
              setFinalTimerFlag={setFinalTimerFlag}
              setCheckThumsDownFeedback={setCheckThumsDownFeedback}
            />
          }
          {!showMinimizedChat && (
            <div style={{ height: "80%", display: "flex", width: "100%" }}>
              <div
                ref={messagesEndRef}
                style={{ height: showMaximumChat && "100%" }}
                className={
                  showMaximumChat ? "fullPageBotChatWrap" : "bot-chat-wrap"
                }
              >
                <Conversation
                  setShowMsgs={setShowMsgs}
                  showMsgs={showMsgs}
                  messages={messages}
                  updateMessage={updateMessage}
                  setIsFeedbackPop={setIsFeedbackPop}
                  isFeedbackPop={isFeedbackPop}
                  clearMessages={clearMessages}
                  loading={loading}
                  showMaximumChat={showMaximumChat}
                  scrollToBottom={scrollToBottom}
                  token={token}
                  sessionId={sessionId}
                  startLogin={startLogin}
                  setIsThirtyMinPopUP={setIsThirtyMinPopUP}
                  IsThirtyMinPopUP={IsThirtyMinPopUP}
                  setIsShowBot={setIsShowBot}
                  setDisableInputBox={setDisableInputBox}
                  checkThumsDownFeedback={checkThumsDownFeedback}
                  setCheckThumsDownFeedback={setCheckThumsDownFeedback}
                  setIndexForPopUp={setIndexForPopUp}
                />
              </div>
              {messages?.length !== 0 && showMaximumChat && (
                <RelatedArticles
                  showMaximumChat={showMaximumChat}
                  clearMessages={clearMessages}
                  setShowMsgs={setShowMsgs}
                />
              )}
            </div>
          )}
          {!showMinimizedChat && (
            <div
              style={{
                display: "flex",
                justifyContent: checkIntroPage() ? "center" : "",
                height: "12%",
              }}
            >
              <Footer
                inputValue={inputValue}
                handleInput={handleInput}
                handleSend={handleSend}
                handleKeyPress={handleKeyPress}
                showMaximumChat={showMaximumChat}
                checkIntroPage={checkIntroPage}
                disableInputBox={disableInputBox}
                loading={loading}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
